export default __webpack_public_path__ + "assets/images/06853f9dcf3caa975457ffc52f250054.png";